// extracted by mini-css-extract-plugin
export var arrow = "menu-module--arrow--33761";
export var container = "menu-module--container--1309e";
export var mainTitle = "menu-module--mainTitle--6bbbf";
export var menu = "menu-module--menu--f058b";
export var menuOpened = "menu-module--menuOpened--319c7";
export var menuTitle = "menu-module--menuTitle--2ce99";